import type { TOC } from '@ember/component/template-only';
import HotelMarketInsightChartsLegendLegendItem from 'lumen/components/hotel/market-insight/charts/legend/legend-item';

interface HotelMarketInsightChartsChartSolidgaugeLegendSignature {
  Args: {
    legendInfo: unknown;
  };
}

const HotelMarketInsightChartsChartSolidgaugeLegend = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div
    class="chart-legend chart-legend--availability flex flex-col justify-center"
  >
    {{#each @legendInfo as |point|}}
      <HotelMarketInsightChartsLegendLegendItem
        @color={{point.color}}
        @name={{point.name}}
        @value="{{point.value}}%"
      />
    {{/each}}
  </div>
</template> satisfies TOC<HotelMarketInsightChartsChartSolidgaugeLegendSignature>;

export default HotelMarketInsightChartsChartSolidgaugeLegend;
